import { createAuth0 } from '@auth0/auth0-vue'
import { REDIRECT_URL } from '../d.env'

export default defineNuxtPlugin((nuxtApp) => {
  const auth0 = createAuth0({
    domain: 'login.craftstory.com',
    clientId: 'fZF30ntWGxbwaUcbeVqJcYrYOL2Czti3',
    cacheLocation: 'localstorage',
    authorizationParams: {
      redirect_uri: REDIRECT_URL,
    },
  })

  if (import.meta.client) {
    nuxtApp.vueApp.use(auth0)
  }
})
